<button
  [type]="type"
  [class]="buttonClasses"
  [disabled]="disabled"
  (click)="onClick($event)">    
 
  <!-- Button Content -->
  <span class="button-content" >
    <ng-content></ng-content>
  </span>

</button>